import { ButtonBase, Dialog, Divider, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Attachment, Ticket } from "../../services/swagger";
import FormTemplate from "../templates/FormTemplate";
import PdfIcon from "../../assets/pdf-icon.webp";
import DeleteButton from "../atoms/DeleteButton";
import useConfirm from "../../hooks/useConfirm";
import { PrintService } from "../../services/api";
import useRefresh from "../../hooks/useRefresh";
import { getDownloadSrc } from "../../helpers/download";

interface TicketPrintLogProps {
  attachment: Attachment;
  ticketId: string;
  onDelete: () => any;
}

function TicketPrintLog(props: TicketPrintLogProps) {
  const handlleClick = () => {
    return window.open(
      getDownloadSrc(props.attachment.path, props.ticketId, {
        disableForceDownload: true,
        mimeType: "application/pdf",
      }),
      "_blank"
    );
  };
  return (
    <Stack>
      <Stack
        direction="row"
        spacing={2}
        justifyContent="space-between"
        alignItems="center"
      >
        <ButtonBase
          onClick={handlleClick}
          sx={{ flexGrow: 1, p: 0.5, justifyContent: "flex-start" }}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <img
              src={PdfIcon}
              style={{
                height: 30,
                width: 30,
                objectFit: "cover",
                borderRadius: "inherit",
              }}
            />
            <Typography>{props.attachment.name}</Typography>
          </Stack>
        </ButtonBase>
        <DeleteButton onClick={props.onDelete} />
      </Stack>
      <Divider />
    </Stack>
  );
}

interface TicketPrintLogsDialogProps {
  open: boolean;
  ticket: Ticket;
  onClose?: () => void;
}

export default function TicketPrintLogsDialog(
  props: TicketPrintLogsDialogProps
) {
  const { t } = useTranslation("TicketPrintLogsDialog");
  const confirm = useConfirm();
  const refresh = useRefresh();

  const handleDelete = (index: number) => {
    confirm(async () => {
      if (!props.ticket._id) return;
      const res = await PrintService.deleteTicketPrintLog({
        ticketId: props.ticket._id,
        printLogIndex: index,
      });
      if (res?.data?.success) refresh();
    });
  };

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <FormTemplate
        title={t("PrintLogs")}
        disableFooter
        onCancel={props.onClose}
      >
        {props.ticket.printLogs.length > 0 ? (
          props.ticket.printLogs.map((e, i) => (
            <TicketPrintLog
              attachment={e}
              ticketId={props.ticket._id || ""}
              onDelete={() => handleDelete(i)}
            />
          ))
        ) : (
          <Typography color="text.secondary">
            {t("NoPrintLogsFound")}
          </Typography>
        )}
      </FormTemplate>
    </Dialog>
  );
}
